"use client"
import { useNavigate } from "react-router-dom"

const LoadingOverlay = ({ loading, uploadProgress }) => {
  const navigate = useNavigate()

  if (!loading) return null

  return (
    <div className="order-loading-overlay">
      <div className="order-loading-container">
        <div className="order-spinner-section">
          <div className="order-spinner"></div>
          <p className="order-loading-text">Processing your order...</p>
        </div>

        {(uploadProgress.po > 0 || uploadProgress.payment > 0) && (
          <div className="order-upload-progress">
            {uploadProgress.po > 0 && <p>PO File: {Math.round(uploadProgress.po)}%</p>}
            {uploadProgress.payment > 0 && <p>Payment File: {Math.round(uploadProgress.payment)}%</p>}
          </div>
        )}

        <button className="order-cancel-btn" onClick={() => navigate("/dashboard")}>
          Cancel & Go to Dashboard
        </button>
      </div>
    </div>
  )
}

export default LoadingOverlay
